import React, { useEffect, useMemo, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import {
  ConstructionTypeOptions,
  governmentBuildingOptions,
  landUsesTypeList,
  proposedSite,
  schemeTypeList,
  subUsesTypeList,
  tehsilData,
  yesOrNo,
} from "../../../../TCPForms/data";
import { Col, Container, Row } from "react-bootstrap";
import { Table, TableContainer } from "@mui/material";
import { IconButton } from "@mui/material";
import RemoveIcon from "@mui/icons-material/HighlightOff";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import { useSelector } from "react-redux";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";

const SubStep4 = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  t,
  landSubUseTypes,
  landUseListActivities,
  landUsesSchemeTypeList,
  landSubUseTypes2,
  tenantId,
  departmentList,
  schemeTypeData,
  nonSchemeTypeData,
  avpList,
  applicationFlow,
  avpData,
  isEmployee,
  isApproved,
}) => {
  const isDA = formData?.department === "DA";
  const [coordinate, setCoordinate] = useState([{ latitude: "", longitude: "" }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData?.descriptionOfLand?.plotAreaSite);
  const { documents } = useSelector((state) => state.formMT);

  console.log("FormData1212", formData, isApproved, isEmployee);

  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
      googleMapCoordinates: formData?.descriptionOfLand?.googleMapCoordinates || coordinate,
      googleMapLocation: formData?.descriptionOfLand?.googleMapLocation || googleLocation,
      schemeType: formData?.descriptionOfLand?.schemeType || "",
      roadWidths: formData?.descriptionOfLand?.roadWidths || [{ value: "" }],
      approachRoadWidths: formData?.descriptionOfLand?.approachRoadWidths || [{ value: "" }],
      otherSides: formData?.descriptionOfLand?.otherSides || [{ value: "" }],
      multipleKhata: formData?.descriptionOfLand?.multipleKhata || [{ value: "" }],
      khasraDetails: formData?.descriptionOfLand?.khasraDetails || [{ district: "", tehsil: "", village: "", plotNo: "" }],
      multipleKhasra: formData?.descriptionOfLand?.multipleKhasra || [{ khasraNo: "", area: "" }],
      // khasraWithArea:formData?.
    },
  };
  const { handleSubmit, control, watch, reset, setValue } = useForm({ defaultValues });
  const handleCoordinateChange = (field, value) => {
    setCoordinate((prev) => {
      const newCoordinates = [...prev];
      newCoordinates[0] = { ...newCoordinates[0], [field]: value };
      return newCoordinates;
    });
  };

  const handleGoogleLocation = (e) => {
    setGoogleLocation(e.target.value);
  };
  const { fields: multipleKhasra, append: addKhasra, remove: removeKhasra } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra",
  });
  const { fields: roadWidthsArray, append: addRoadWidthField, remove: removeRoadWidthField } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths",
  });
  const { fields: otherSides, append: addOtherSide, remove: removeOtherSide } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides",
  });
  const { fields: approachRoadWidths, append: addApproachRoad, remove: removeApproachWidth } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths",
  });
  const { fields: multipleKhata, append: addKhata, remove: removeKhata } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata",
  });
  const { fields: khasraDetails, append: addKhasraDetail, remove: removeKhasraDetail } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails",
  });

  // const [subLandUseType, setSubLandUseType] = useState({});
  // const { data: { AuthorityMasterData: { Organizations: departmentList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(
  //   tenantId,
  //   "AuthorityMasterData",
  //   ["Organizations"]
  // );
  console.log("departmentListFrom444", schemeTypeData, nonSchemeTypeData);

  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const watchMaster = watch("descriptionOfLand.landUsesType");
  const watchActivityAsPerMap = watch("descriptionOfLand.activityAsPerMap");
  const watchSubLayout = watch("descriptionOfLand.subLandUseAsPerLayout");
  const watchPlanOn = watch("descriptionOfLand.planOn");
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails",
  });
  const watchGovernmentBuilding = watch("isGovernmentBuilding");

  const { data: { BPA: { LandUseVillageMasterData: villagesData } = {} } = {}, isLoading: isVillagesLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    [{ name: "LandUseVillageMasterData", filter: `$[?(@.authorityName=="${formData?.selectedOffice}")]` }]
  );
  const { data: { BPA: { LandUseAvpVillageMasterData: avpVillagesData } = {} } = {}, isLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    {
      name: "LandUseAvpVillageMasterData",
      filter: `$..Districts[?(@.District=='${formData?.selectedCity}')]`,
    },
  ]);
  console.log("loggingVillagesData", villagesData, avpVillagesData);
  const filterTehsilData = (masterData, authority, district) => {
    console.log("filterTehsilDataCalled", masterData, authority);

    const result =
      district && authority
        ? masterData
            ?.find((item) => item.authorityName === authority)
            ?.Districts?.find((item) => item.District === district)
            ?.tehsils?.map((item) => {
              return { name: item.tehsilName, label: item.tehsilName, value: item.tehsilName };
            })
        : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterAvpTehsilData = (masterData, district) => {
    const tehsilArray = masterData
      ?.find((item) => item.District === district)
      ?.tehsils?.map((item) => ({ name: item.tehsilName, label: item.tehsilName, value: item.tehsilName }));
    return tehsilArray || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = (str) =>
      str
        ?.split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    const result =
      tehsil && district && authority
        ? masterData
            ?.find((item) => item?.authorityName === authority)
            ?.Districts?.find((item) => item?.District === district)
            ?.tehsils?.find((item) => item?.tehsilName === tehsil)
            ?.villages?.map((item) => {
              const formatted = toTitleCase(item);
              return { name: formatted, value: formatted, label: formatted };
            })
        : null;
    return result || [];
  };
  const filterAvpVillagesData = (masterData, district, tehsil) => {
    const villagesArray = masterData
      ?.find((item) => item.District === district)
      ?.tehsils?.find((item) => item.tehsilName === tehsil)
      ?.villages?.map?.((item) => ({ name: item, label: item, value: item }));
  };
  const filterDistrictData = (masterData, authority) => {
    const districtsArray = masterData
      ?.find((item) => item.authorityName === authority)
      ?.Districts?.map((item) => {
        return { name: item?.District, label: item?.District, value: item?.District };
      });
    console.log("districtArray", districtsArray);
    // districtsArray?.length>1?:
    return districtsArray || [];
  };
  // const tehsils = filterTehsilData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority");
  // const villages = filterVillagesData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority", watchTehsil);
  // console.log("villagesFinalFromFilter", villages, tehsils);
  const filterCategoryData = (allCategories) => {};
  const isSchemeType = watchSchemeType === "Scheme";
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    console.log("schemeDataCalled", authority, masterData, category, subCategory);

    // First, find the relevant data once and store it
    const authorityData = masterData?.[0];

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
        label: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
            value: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  console.log("upDIstricts", updistricts);

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    // const landUseList = masterData
    // ?.filter((item) => item.name === authority)
    // .map((item) => item.LandUse)
    // .flat()
    // .map((item) => {
    //   return { name: item.Type, value: item.Type };
    // });
    const landUseList = masterData?.[0]?.CategoryType?.map((item) => {
      return { name: item.Category, label: item.Category, value: item.Category };
    });
    const landSubUseList = masterData?.[0]?.CategoryType?.filter((item) => item.Category === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item, value: item };
    });
    // const landSubUseList = masterData
    // ?.filter((item) => item.name === authority)?.[0]
    //   ?.LandUse?.filter((item) => item.Type === category)?.[0]
    //   ?.LandSubUse?.map((item) => {
    //     return {
    //       name: item,
    //       label: item,
    //     };
    //   });
    // ?.map((item) => {
    //   return { name: item, label: item };
    // });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = filterSchemeData(
    isDA ? formData?.selectedOffice : "Lucknow Development Authority",
    schemeTypeData,
    watchMaster,
    watchSubLayout
  );
  // : filterNonSchemeData(formData?.selectedOffice, nonSchemeTypeData, watchMaster, watchSubLayout);
  const plotNo = watch("descriptionOfLand.plotNo");
  const { landUseList: activityAsPerMap, landSubUseList: activityProposed } = filterNonSchemeData(
    formData?.selectedOffice,
    nonSchemeTypeData,
    watchActivityAsPerMap,
    watchSubLayout
  );
  console.log("activityAsPerMap", activityAsPerMap);

  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData
      ?.filter((item) => item.Name === department)
      .map((item) => item.ColonyGroups)
      .flat()
      .filter((item) => item.ColonyType === planOn)
      .map((item) => item.Colonies)
      .flat()
      .map((item) => {
        return { name: item, label: item, value: item };
      });
    console.log("schemeFilteredData", schemeNameList);

    return schemeNameList;
  };
  const schemeNames = filterSchemeNames(departmentList, formData?.selectedOffice, watchPlanOn);
  const filterAvpSchemeNames = (unit, city, masterData) => {
    console.log("avpMasterFrom4", masterData, unit, city);

    const result = masterData
      ?.filter((item) => item.Unit === unit)?.[0]
      ?.Cities?.filter((item) => item.City === city)?.[0]
      ?.Schemes?.map((item) => {
        return { name: item.SchemeName, label: item.SchemeName, value: item.SchemeName };
      });
    console.log("loggingAVPSchemeNames", result);
    return result;
  };
  const avpSchemeNames = filterAvpSchemeNames(formData?.selectedUnit, formData?.selectedCity, avpData);
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs = ["kmlFile"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const onSubmit = (data) => {
    const isValid = validateFiles();

    console.log("insideFormSubmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleSubTabChange(3, data);
      // handleTabChange(1, data);
      // onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    if (formData?.descriptionOfLand?.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
      setValue("landInfo.owners[0].permanentAddress.district", formData?.location1);
    }

    setValue("documents", documents);

    if (formData?.location1 && khasraDetails?.length > 0) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.location1);
      });
    }
  }, [formData, documents, khasraDetails]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);

  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Land Information")}</h2>
          </div>
          <Container className="formInputContainer common-app-form px-4" fluid>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Scheme Type"
                  inputLabel="Select Scheme Type"
                  placeholder="Select Scheme Type"
                  name="descriptionOfLand.schemeType"
                  type="searchSelect"
                  defaultValue={formData?.descriptionOfLand?.schemeType}
                  data={SortingAlphabatically(schemeTypeList)}
                  disabled={isEmployee || isApproved}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <div
                  style={{
                    // padding: "6px",
                    borderRadius: "5px",
                    color: "#333",
                    margin: "9px 0px",
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                >
                  <span style={{ textAlign: "right", color: "rgb(2, 11, 15)", padding: "9px", backgroundColor: "#fff" }}>
                    <span className="clickHere" onClick={handleClick}>
                      Click here,
                    </span>
                    &nbsp;to know how to create a .kml file.
                  </span>
                </div>
              </Col>
            </Row>
            {isSchemeType && (
              <React.Fragment>
                <Row>
                  {" "}
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      // backgroundColor: "#f5f5f5",
                      // padding: "10px",
                      borderRadius: "5px",
                      color: "#333",
                      margin: "9px 4px",
                      fontWeight: "700",
                    }}
                  >
                    <span style={{ backgroundColor: "#f2f2f2", color: "red", padding: "4px" }}>
                      Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission.
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Type of Scheme"
                      placeholder="Select type of scheme"
                      name={`descriptionOfLand.planOn`}
                      type={formData?.descriptionOfLand?.planOn || isEmployee || isApproved ? "textInput" : "searchSelect"}
                      maxLength={30}
                      data={SortingAlphabatically(proposedSite)}
                      defaultValue={formData?.descriptionOfLand?.planOn}
                      mandatory
                      disabled={isEmployee || isApproved}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>

                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Name of Scheme"
                      placeholder="Select Name of Scheme"
                      name={`descriptionOfLand.schemeName`}
                      type={formData?.descriptionOfLand.schemeName || isEmployee || isApproved ? "textInput" : "searchSelect"}
                      maxLength={30}
                      data={isDA ? SortingAlphabatically(schemeNames) : SortingAlphabatically(avpSchemeNames)}
                      defaultValue={formData?.descriptionOfLand?.schemeName}
                      mandatory
                      disabled={isEmployee || isApproved}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <Row>
              {/* {!isSchemeType && ( */}
              {/* (formData?.descriptionOfLand?.schemeType === "Non Scheme" && formData?.descriptionOfLand?.landUsesType)) && ( */}
              <React.Fragment>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={isSchemeType ? "Land Use as per Layout Plan" : "Land Use as per Master Plan"}
                    inputLabel="Select a plan."
                    placeholder={isSchemeType ? "Select Land Use as per Layout Plan" : "Select Land Use as per Master Plan"}
                    name="descriptionOfLand.landUsesType"
                    type={isEmployee || isApproved ? "textInput" : "searchSelect"}
                    mandatory={true}
                    isRequired={true}
                    disabled={isEmployee || isApproved}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.descriptionOfLand?.landUsesType}
                    data={SortingAlphabatically(landUseList)}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={isSchemeType ? "Land Sub Use as per Layout Plan" : "Land Sub Use as per Master Plan"}
                    control={control}
                    placeholder={isSchemeType ? "Select Land Sub Use as per Layout Plan" : "Select Land Sub Use as per Master Plan"}
                    name="descriptionOfLand.subLandUseAsPerLayout"
                    type={isEmployee || isApproved ? "textInput" : "searchSelect"}
                    data={SortingAlphabatically(landSubUseList)}
                    disabled={isEmployee || isApproved}
                    mandatory
                    maxLength={150}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout}
                  />
                </Col>
              </React.Fragment>
              {/* )} */}
            </Row>
            {/* {isSchemeType && ( */}
            {/* (formData?.descriptionOfLand?.landUsesType === "Scheme" && formData?.descriptionOfLand?.landUsesType)) && ( */}

            <Row>
              <React.Fragment>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    data={SortingAlphabatically(activityAsPerMap)}
                    label={t("Primary Use of Proposed Activity")}
                    placeholder={t("Select Primary Use of Proposed Activity")}
                    name="descriptionOfLand.activityAsPerMap"
                    defaultValue={formData?.descriptionOfLand?.activityAsPerMap}
                    type={isEmployee || isApproved ? "textInput" : "searchSelect"}
                    mandatory
                    disabled={isEmployee || isApproved}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={t("Activity Proposed")}
                    control={control}
                    placeholder={t("Select Activity Proposed")}
                    name="descriptionOfLand.activityProposed"
                    type={isEmployee || isApproved ? "textInput" : "searchSelect"}
                    data={SortingAlphabatically(activityProposed)}
                    mandatory
                    disabled={isEmployee || isApproved}
                    maxLength={20}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.descriptionOfLand?.activityProposed}
                  />
                </Col>
              </React.Fragment>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label={t("Development Area")}
                  control={control}
                  placeholder={t("Select Development Area")}
                  data={SortingAlphabatically(ConstructionTypeOptions)}
                  name="descriptionOfLand.developmentArea"
                  mandatory
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  defaultValue={formData?.descriptionOfLand?.constructionType}
                  type="searchSelect"
                />
              </Col>
              <Col></Col>
              {/* {!isSchemeType ? (
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={t("Does your land fall under more than one village?")}
                    control={control}
                    placeholder={t("Select yes/no")}
                    data={SortingAlphabatically(yesOrNo)}
                    name="descriptionOfLand.multipleVillages"
                    mandatory
                    disabled={isEmployee || isApproved}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    isRequired={true}
                    defaultValue={formData?.descriptionOfLand?.multipleVillages}
                    type="radioButton"
                  />
                </Col>
              ) : (
                <Col></Col>
              )} */}
            </Row>
            {/* <Row>
              {(!isSchemeType || formData?.descriptionOfLand?.selectLandUse) && (
                <Col>
                  <InputWrapper
                    control={control}
                    label="Permissibility of Activities"
                    inputLabel="Select activities."
                    placeholder="Select activities."
                    name="descriptionOfLand.selectLandUse"
                    type="searchSelect"
                    disabled={isEmployee || isApproved}
                    // defaultValue={formData?.descriptionOfLand?.selectLandUse}
                    data={SortingAlphabatically(landUseListActivities)}
                  />
                </Col>
              )}
              {(!isSchemeType || formData?.descriptionOfLand?.proposedActivity) && (
                <Col>
                  <InputWrapper
                    control={control}
                    label="Proposed Activity as per Zoning Regulation"
                    placeholder="Enter activity"
                    name={`descriptionOfLand.proposedActivity`}
                    type="textInput"
                    maxLength={30}
                    disabled={isEmployee || isApproved}
                    height="40px"
                  />
                </Col>
              )}
            </Row> */}
            {!isSchemeType ? (
              <fieldset className="fieldset-wrapper bg-white">
                {/* <legend style={{ fontWeight: "bold", fontSize: "1rem" }}>Land/Khasra Details</legend> */}
                <TableContainer className="table-container">
                  <Table stickyHeader className="application-table landUserTable" border="1" cellPadding="8">
                    <thead
                      className="table-no-background"
                      style={{
                        background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                        // background: "#f0f0f0"
                      }}
                    >
                      <tr>
                        <th style={{ width: "25%" }}>
                          {t("LABEL_DISTRICT")}
                          <span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "20%" }}>
                          {t("Tehsil")}
                          <span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "20%" }}>
                          Village<span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "25%" }}>
                          Plot No./Khasra No./Arazi No.<span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "10%" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {khasraDetails.map((item, index) => {
                        const selectedTehsil = khasraTehsils?.[index]?.tehsil;
                        const selectedDistrict = khasraTehsils?.[index]?.district;
                        const filteredVillages = isDA
                          ? filterVillagesData(
                              villagesData,
                              isDA ? formData?.selectedOffice : "Lucknow Development Authority",
                              selectedDistrict,
                              selectedTehsil
                            )
                          : filterAvpVillagesData(avpVillagesData, selectedDistrict, selectedTehsil);
                        const tehsils = isDA
                          ? filterTehsilData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority", selectedDistrict)
                          : filterAvpTehsilData(avpVillagesData, selectedDistrict);
                        return (
                          <tr key={item.id}>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                data={SortingAlphabatically(
                                  filterDistrictData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority")
                                )}
                                placeholder="Select District"
                                name={`descriptionOfLand.khasraDetails[${index}].district`}
                                type={
                                  !isDA || formData?.descriptionOfLand?.khasraDetails?.[index]?.district || isEmployee || isApproved
                                    ? "textInput"
                                    : "searchSelect"
                                }
                                defaultValue={formData?.location1}
                                disabled={isEmployee || isApproved}
                                mandatory
                                isRequired
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                data={SortingAlphabatically(tehsils)}
                                placeholder="Select Tehsil"
                                name={`descriptionOfLand.khasraDetails[${index}].tehsil`}
                                defaultValue={formData?.descriptionOfLand?.khasraDetails?.[index]?.tehsil}
                                type={
                                  tehsils?.length < 1 || formData?.descriptionOfLand?.khasraDetails?.[index]?.tehsil || isEmployee || isApproved
                                    ? "textInput"
                                    : "searchSelect"
                                }
                                disabled={isEmployee || isApproved}
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                data={SortingAlphabatically(filteredVillages)}
                                placeholder="Select Village"
                                name={`descriptionOfLand.khasraDetails[${index}].village`}
                                defaultValue={formData?.descriptionOfLand?.khasraDetails?.[index]?.village}
                                type={
                                  tehsils?.length < 1 || formData?.descriptionOfLand?.khasraDetails?.[index]?.village || isEmployee || isApproved
                                    ? "textInput"
                                    : "searchSelect"
                                }
                                maxLength={30}
                                disabled={isEmployee || isApproved}
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                // label=""
                                width={"100%"}
                                hasLabel={false}
                                control={control}
                                placeholder="Enter Plot No./Khasra No./Arazi No."
                                mandatory
                                name={`descriptionOfLand.khasraDetails[${index}].plotNo`}
                                type="specialChar"
                                allowedChars="/,-"
                                maxLength={200}
                                disabled={isEmployee || isApproved}
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {index > 0 && (
                                <IconButton onClick={() => removeKhasraDetail(index)} disabled={isEmployee || isApproved}>
                                  <RemoveIcon />
                                </IconButton>
                              )}
                              {index === khasraDetails.length - 1 && (
                                <IconButton
                                  onClick={() => addKhasraDetail({ plotNo: "", district: "", tehsil: "", village: "" })}
                                  disabled={isEmployee || isApproved}
                                >
                                  <AddIcon />
                                </IconButton>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </TableContainer>
              </fieldset>
            ) : (
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label="Plot No."
                    control={control}
                    placeholder="Enter Plot No."
                    mandatory={true}
                    name="descriptionOfLand.plotNo"
                    type="specialChar"
                    allowedChars="/,-"
                    maxLength={200}
                    disabled={isEmployee || isApproved}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>

                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    data={SortingAlphabatically(filterDistrictData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority"))}
                    label={t("LABEL_DISTRICT")}
                    placeholder="Select District"
                    name="landInfo.owners[0].permanentAddress.district"
                    type={isDA ? "searchSelect" : "textInput"}
                    defaultValue={!isDA && formData?.selectedCity}
                    mandatory
                    disabled={isEmployee || isApproved}
                    isRequired={true}
                    validation={{
                      required: {
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Plot area (as per document) (sq. m)"
                  placeholder="Enter Plot area (as per document) (sq. m)"
                  // defaultValue={formData?.descriptionOfLand?.landArea}
                  // value={totalPlotAreaVal}
                  name="descriptionOfLand.plotAreaDoc"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  validation={{
                    required: {
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={6}
                  disabled={isEmployee || isApproved}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Plot area (as per site) (sq. m)"
                  placeholder="Enter Plot area (as per site) (sq. m)"
                  // defaultValue={formData?.descriptionOfLand?.landArea}
                  // value={totalPlotAreaVal}
                  name="descriptionOfLand.landArea"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  message="The value must not exceed plot area as per document"
                  maxValue={maxPlotAreaSite}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={6}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {roadWidthsArray.map((field, index) => (
                  <div style={{ display: "flex", position: "relative" }}>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Road width (existing) (m)"
                      placeholder="Enter Road width (existing) (m)"
                      // defaultValue={field.value}
                      name={`descriptionOfLand.roadWidths.${index}.value`}
                      type="specialChar"
                      allowedChars="."
                      onlyNumeric={true}
                      mandatory
                      disabled={isEmployee || isApproved}
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={5}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                    {!isEmployee && !isApproved && (
                      <div className="adornment" style={{ position: "absolute", right: "0px" }}>
                        {index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && (
                          <IconButton
                            sx={{ color: "#000" }}
                            aria-label="Add more"
                            disabled={roadWidthsArray.length >= 4}
                            onClick={() => addRoadWidthField({ value: "" })}
                          >
                            <AddIcon sx={{ color: "#000" }} />
                          </IconButton>
                        )}
                        {roadWidthsArray.length > 1 && index > 0 && (
                          <IconButton color="error" aria-label="Delete" onClick={() => removeRoadWidthField(index)}>
                            <RemoveIcon />
                          </IconButton>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </Col>
              <Col>
                {approachRoadWidths.map((field, index) => (
                  <div style={{ display: "flex", position: "relative" }}>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label={isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)"}
                      placeholder={isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)"}
                      // defaultValue={field.value}
                      name={`descriptionOfLand.approachRoadWidths.${index}.value`}
                      type="specialChar"
                      allowedChars="."
                      onlyNumeric={true}
                      mandatory
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={5}
                      sx={{ Padding: "0px" }}
                      disabled={isEmployee || isApproved}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                    {!isEmployee && !isApproved && (
                      <div className="adornment" style={{ position: "absolute", right: "0px" }}>
                        {index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && (
                          <IconButton
                            sx={{ color: "#000" }}
                            aria-label="Add more"
                            disabled={approachRoadWidths.length >= 4}
                            onClick={() => addApproachRoad({ value: "" })}
                          >
                            <AddIcon sx={{ color: "#000" }} />
                          </IconButton>
                        )}
                        {approachRoadWidths.length > 1 && index > 0 && (
                          <IconButton color="error" aria-label="Delete" onClick={() => removeApproachWidth(index)}>
                            <RemoveIcon />
                          </IconButton>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </Col>
            </Row>
            <Row>
              <Col onChange={(e) => handleCoordinateChange("latitude", e.target.value)}>
                <InputWrapper
                  width={"100%"}
                  label="Latitude"
                  control={control}
                  placeholder="Enter Latitude"
                  name="descriptionOfLand.latitude"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  disabled={isEmployee || isApproved}
                  isRequired={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Coordinates"),
                      message: "Value cannot be zero. Please provide valid coordinate.",
                    },
                  }}
                  minLength={8}
                  maxLength={10}
                />
              </Col>
              <Col onChange={(e) => handleCoordinateChange("longitude", e.target.value)}>
                <InputWrapper
                  width={"100%"}
                  label="Longitude"
                  control={control}
                  placeholder="Enter Longitude"
                  name="descriptionOfLand.longitude"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Coordinates"),
                      message: "Value cannot be zero. Please provide valid coordinate.",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                  minLength={8}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Land Address"
                  control={control}
                  placeholder="Enter Land Address"
                  defaultValue={formData?.descriptionOfLand?.landAddress}
                  name="descriptionOfLand.landAddress"
                  type="specialChar"
                  allowedChars="_&:,/. -"
                  mandatory
                  disabled={isEmployee || isApproved}
                  maxLength={30000}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Nearby Landmark"
                  control={control}
                  placeholder="Enter Nearby Landmark"
                  defaultValue={formData?.descriptionOfLand?.landMark}
                  name="descriptionOfLand.landMark"
                  type="specialChar"
                  allowedChars="_&:,/. -"
                  mandatory
                  required
                  disabled={isEmployee || isApproved}
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={[
                    { label: "Yes", value: "yes" },
                    { label: "No", value: "no" },
                  ]}
                  label={t("Is this a Government Building ?")}
                  name="isGovernmentBuilding"
                  defaultValue={formData?.isGovernmentBuilding}
                  disabled={isEmployee || isApproved}
                  type="radioButton"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              {watchGovernmentBuilding === "yes" ? (
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={t("Government Building")}
                    control={control}
                    placeholder={t("Select Government Building")}
                    data={SortingAlphabatically(governmentBuildingOptions)}
                    name="governmentBuildingName"
                    mandatory
                    disabled={isEmployee || isApproved}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    isRequired={true}
                    defaultValue={formData?.governmentBuildingName}
                    type="searchSelect"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              <Col>
                <div className="custom-upload new-custom-uploader">
                  {!isEmployee && !isApproved && (
                    <KmlFileUploader
                      name={"kmlFile"}
                      label={"KML File"}
                      isMandatory
                      validationMsg={"(.kml file only and Max file Size 10 MB)"}
                      required
                      tab={1}
                      showError={showError}
                      // control={control}
                      maxFiles={1}
                    />
                  )}
                </div>
              </Col>
              <Col></Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            {!isEmployee && !isApproved && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(2)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#000", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep4;
